export default __webpack_public_path__ + "static/media/sounds/ran_numbers_nine.mp3";